export const hello = () => 'hello';

export * from './consultArea';
